import { render, staticRenderFns } from "./ViewDeals.vue?vue&type=template&id=5603fee3&scoped=true"
import script from "./ViewDeals.vue?vue&type=script&lang=js"
export * from "./ViewDeals.vue?vue&type=script&lang=js"
import style0 from "./ViewDeals.vue?vue&type=style&index=0&id=5603fee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603fee3",
  null
  
)

export default component.exports